
				var addMethods = require("../../../.yarn/$$virtual/workerize-loader-virtual-369ff6c8ac/0/cache/workerize-loader-npm-1.1.0-303cc282de-2.zip/node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getTodayBookings","refreshBookingStationTimePlayingAndEndTime","isEqual"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "83896eb2723a593ed474.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			